module.exports = __webpack_public_path__ + "static/img/FLIP_ESSENTIAL.92b55b3c.jpg";